export default "__VITE_PUBLIC_ASSET__ff17a326__"